export const ERROR_CODES = {
    CODE_400: 400,
    CODE_401: 401,
    CODE_402: 402,
    CODE_403: 403,
    CODE_404: 404,
    CODE_405: 405,
    CODE_409: 409,
    CODE_422: 422,
    CODE_500: 500,
    CODE_900: 900,
    CODE_200: 200,
    CODE_204: 204,
    CODE_300: 300,
};

export const ERRORS: { [key: string]: string } = {
    er200: 'Поле обязательно для заполнения',
    er201: 'Значение поля слишком маленькое',
    er202: 'Значение поля слишком большое',
    er203: 'Введите корректное значение',
    er204: 'Неверный email',
    er205: 'Не удалось зарегистрировать пользователя, попробуйте еще раз',
    er206: 'В поле содержатся недопустимые символы',
    er207: 'Значение поля не является электронной почтой',
    er208: 'Ошибка электронной почты. Возможно такой email уже существует',
    er209: 'Неправильный логин или пароль',
    er210: 'Не удалось подтвердить аккаунт, попробуйте запросить письмо с подтверждением повторно',
    er211: 'Недостаточно прав',
    er212: 'Пароли не совпадают',
    er213: 'Не удалось сменить пароль',
    er214: 'Страница не найдена',
    er215: 'Один или несколько файлов повреждены или превышают допустимый размер',
    er216: 'Один или несколько файлов имеют неверный тип',
    er217: 'Не удалось обновить аватар',
    er218: 'Не найден confirmationGuid. Попробуйте ввести email заново',
    er219: 'Данные не являются числом',
    er220: 'Не удалось сохранить аватар',
    er221: 'Неверная длина значения',
    er222: 'Дата не попадает в корректный диапазон',
    er223: 'Некорректная дата',
    er224: 'Некорректный номер телефона',
    er225: 'Некорректный логин Телеграм',
    er226: 'Ошибка авторизации',
    er227: 'Неправильный код подтверждения',
    er228: 'Выберите сезон',
    er229: 'Добавьте хотя бы один элемент одежды',
    er230: 'Не верная дата или диапазон дат',
    er231: 'Не удалось создать чемодан',
    er232: 'Необходимо выбрать дату начала поездки',
    er233: 'Не удалось поделиться',
    er234: 'Не удалось обновить образ',
    er235: 'Не удалось удалить образ',
    er236: 'Выберите хотя бы один сезон',
    er237: 'Пароль должен содержать не менее 8 символов',
    er239: 'Произошла ошибка при удалении изделия',
    er240: 'Название должно содержать не менее 3 символов',
    er241: 'Название не должно превышать 100 символов',
    er242: 'Выберите город из списка',
    er243: 'Выберите тип поездки',
    er244: 'Выберите обложку чемодана',
    er245: 'Дата окончания не может быть раньше даты начала',
    er246: 'Не удалось создать образ',
    er247: 'Не удалось загрузить образ',
    er248: 'Для продолжения необходимо согласиться с «Условиями использования» и дать согласие на обработку персональных данных',
    er249: 'Не удалось запустить примерку образа',
    er250: 'Не удалось примерить образ',
    er254: 'Создайте хотя бы один образ',
    er255: 'Превышено допустимое количество образов',
    er256: 'Не удалось обновить профиль',
    er257: 'Произошла ошибка при удалении аватара',
    er258: 'Файл имеет неверный тип',
    er259: 'Файл превышает допустимый размер',
    er260: 'Не удалось создать образ',
    er261: 'Название не должно превышать 50 символов',
    er262: 'Название должно содержать не менее 2 символов',
    er263: 'Описание должно содержать не менее 10 символов',
    er264: 'Описание не должно превышать 255 символов',
    er265: 'Пароль должен содержать минимум 8 символов, включая заглавную, строчную букву и цифру',
    er266: 'В образе должно быть не менее 2 изделий',
    er270: 'Какие то данные не верны',
    er271: 'Не удалось обновить изделие',
    er272: 'Не удалось добавить изделие',
    er273: 'Не удалось удалить изделие',
    er274: 'Не удалось обновить событие',
    er275: 'Не удалось удалить образ из календаря',
    er276: 'Введите целое число',
    er277: 'Не удалось обработать фото',
    er278: 'Ошибка при обработке фото, используется оригинал',
    er280: 'Не удалось обработать фотографии',
};

export const SERVER_ERRORS: { [key: string]: string } = {
    er400: 'Неверный запрос',
    er401: 'Пользователь не авторизован',
    er403: 'Доступ запрещен',
    er404: 'Страница не найдена',
    er405: 'Метод не разрешен',
    er406: 'Неприемлемый запрос',
    er409: 'Множественное создание запроса',
    er421: 'Токен не найден или недействителен',
    er429: 'Множественное создание запроса',
    er500: 'Внутренняя ошибка сервера',
    er501: 'Функционал не реализован',
    er502: 'Ошибка шлюза',
    er503: 'Сервис недоступен',
    er504: 'Таймаут шлюза',
    er900: 'Неизвестная ошибка',
};

export const SUCCESS_NOTIFY: { [key: string]: string } = {
    s101: 'Аватар успешно обновлен',
    s102: 'Вы успешно авторизовались',
    s103: 'Вы успешно вышли из аккаунта',
    s104: 'Аккаунт успешно подтвержден',
    s105: 'Вы успешно зарегистрировались',
    s106: 'Письмо активации аккаунта успешно отправлено',
    s107: 'Код успешно отправлен',
    s108: 'Профиль успешно обновлен',
    s109: 'Аватар добавлен. Пожалуйста, сохраните профиль, чтобы применить изменения',
    s110: 'Аватар удален. Пожалуйста, сохраните профиль, чтобы применить изменения',
    s111: 'Изделие успешно удалено',
    s112: 'Событие успешно удалено',
    s113: 'Событие успешно обновлено',
    s114: 'Образ успешно удален',
    s115: 'Изделие успешно удалено из гардероба и из образов',
    s116: 'Пароль успешно изменен. Пожалуйста, войдите с новым паролем',
    s117: 'Образ успешно сохранен',
    s118: 'Образ успешно обновлен',
    s119: 'Изделие успешно добавлено',
    s120: 'Изделие успешно обновлено',
    s125: 'Образ успешно удален из календаря',
    s130: 'Аватар успешно сохранен!',
};

export const INFO_NOTIFY: { [key: string]: string } = {
    i101: 'Для регистрации нужно принять соглашение',
    i102: 'Скоро все будет',
    i103: 'Превышен лимит запросов на обработку. В гардероб будет загружена исходная картинка',
};
